// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.j0PfyLGgUdBCeN {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 32px;
  padding-left: var(--ds-space-150, 10px);
  font-weight: var(--ds-font-weight-regular, 400);
  text-decoration: none;
}
.ZAuLR3kYocuDso {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 32px;
  padding-left: var(--ds-space-150, 10px);
  font-weight: var(--ds-font-weight-regular, 400);
  text-decoration: none;
}
.ZAuLR3kYocuDso:hover {
  background-color: var(--dynamic-nav-button-background-color-hovered, hsla(0, 0%, 0%, 0.08));
  text-decoration: none;
}
.body-dark-board-background .ZAuLR3kYocuDso:hover {
  background-color: var(--dynamic-nav-button-background-color-hovered, hsla(0, 0%, 100%, 0.16));
}
html[data-color-mode='dark'] .ZAuLR3kYocuDso:hover {
  background-color: var(--dynamic-nav-button-background-color-hovered, hsla(0, 0%, 100%, 0.16));
}
.ZAuLR3kYocuDso:active {
  background-color: var(--dynamic-nav-button-background-color-pressed, hsla(0, 0%, 0%, 0.16));
}
.body-dark-board-background .ZAuLR3kYocuDso:active {
  background-color: var(--dynamic-nav-button-background-color-pressed, hsla(0, 0%, 100%, 0.3));
}
html[data-color-mode='dark'] .ZAuLR3kYocuDso:active {
  background-color: var(--dynamic-nav-button-background-color-pressed, hsla(0, 0%, 100%, 0.3));
}
.AirswPL7TWxC_3 {
  margin: var(--ds-space-0, 0) var(--ds-space-100, 8px) var(--ds-space-0, 0);
}
.utf84xZb8qAemG {
  flex: 1;
  margin: var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-100, 8px);
  color: var(--dynamic-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ZzQzajx7tug9Ia {
  margin: var(--ds-space-0, 0) var(--ds-space-075, 6px);
  padding: var(--ds-space-050, 4px);
}
.ovSWAM7yuRuSAQ {
  padding: var(--ds-space-050, 4px);
}
.y9HE96X9dKtXBr {
  padding: var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-050, 4px);
  color: var(--ds-text, #172b4d);
}
.y9HE96X9dKtXBr:hover {
  color: var(--ds-text, #172b4d);
}
`, ""]);
// Exports
export var workspaceLinkRow = `j0PfyLGgUdBCeN`;
export var workspaceLink = `ZAuLR3kYocuDso`;
export var joinButtonWrapper = `AirswPL7TWxC_3`;
export var workspaceLinkText = `utf84xZb8qAemG`;
export var shortcutIcon = `ZzQzajx7tug9Ia`;
export var shortcutIconFlagEnabled = `ovSWAM7yuRuSAQ`;
export var newWorkspacePage = `y9HE96X9dKtXBr`;
export default ___CSS_LOADER_EXPORT___;
